// extracted by mini-css-extract-plugin
export default {"statusHeader":"mG8_QU7mO5Dh5C0Nx2Z_","placeHolderShimmer":"L3wLl28meVZ7FW8YqUe7"};